import {Lang} from 'contexts/LangContext';
import {
    ShortConfigParams,
    NavigationConfigMobile,
    NavigationSectionType,
} from 'units/navigation/models';
import getConfigItems from '../constants';
import {getShortCategoryItems} from './utils';

export default function (params: ShortConfigParams): NavigationConfigMobile {
    const {
        locale,
        i18n,
        env,
        serviceCategories = [],
        solutionCategories = [],
        featureFlags,
    } = params;
    const {common, services, features, community, solutions, contacts} = getConfigItems(
        locale,
        i18n,
        env,
    );
    const {lang} = locale;

    return [
        // services
        {
            title: services.title,
            items: getShortCategoryItems(serviceCategories, NavigationSectionType.Services),
            footer: [common.services, common.marketplace, common.statusboard, common.mobileApp],
        },

        // solutions
        {
            title: solutions.title,
            items: getShortCategoryItems(solutionCategories, NavigationSectionType.Solutions),
            footer: [common.solutions],
        },

        // features
        {
            title: features.title,
            items:
                lang === Lang.Ru
                    ? [
                          features.items.prices,
                          features.items['for-business'],
                          featureFlags.scaleNavigation &&
                              features.items['for-education-and-science'],
                          features.items.cases,
                          features.items.security,
                          featureFlags.scaleNavigation && features.items['insurance-offer'],
                          features.items['partners/catalogue'],
                          features.items['docs/support/overview'],
                      ].filter(Boolean)
                    : [
                          features.items.cases,
                          features.items.security,
                          features.items.prices,
                          features.items['docs/support/overview'],
                      ],
            footer:
                lang === Lang.Ru ? [features.boost, features.partnerPropgram] : [features.boost],
        },

        // community
        lang === Lang.Ru && {
            title: community.title,
            items: [
                community.items.features,
                featureFlags.scaleNavigation && community.items['content-program'],
                community.items.events,
                community.items.blog,
            ].filter(Boolean),
        },

        common.prices,
        common.docs,
        lang === Lang.Ru
            ? {
                  title: contacts.title,
                  items: [common.sales, common.tender],
              }
            : common.contact,
    ].filter(Boolean) as NavigationConfigMobile;
}
